// extracted by mini-css-extract-plugin
export default {"ratingNode":"RatingNode_ratingNode__kg2DB"};